exports = module.exports = require("../../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".layer-list{padding:0}.sortable-placeholder{display:block;height:31px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/postcss-loader!/~/eoxc/src/core/views/layers/LayerListView.css
// module id = 1977
// module chunks = 0